/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Share_Streak_HeadlineInputs */

const en_us2_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`full week`);
	return /** @type {LocalizedString} */ (`full weeks in a row`)
	
};

const pt_br2_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana completa`);
	return /** @type {LocalizedString} */ (`semanas seguidas completas`)
	
};

const es_419_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana completa`);
	return /** @type {LocalizedString} */ (`semanas completas seguidas`)
	
};

const pt_pt2_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana completa`);
	return /** @type {LocalizedString} */ (`semanas completas seguidas`)
	
};

const fr_fr2_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semaine complète`);
	return /** @type {LocalizedString} */ (`semaines complètes d'affilée`)
	
};

const de_de2_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`volle Woche`);
	return /** @type {LocalizedString} */ (`volle Wochen am Stück`)
	
};

const it_it2_share_streak_headline = /** @type {(inputs: Share_Streak_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`settimana completa`);
	return /** @type {LocalizedString} */ (`settimane complete di fila`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "full week" |
* | * | "full weeks in a row" |
*
* @param {Share_Streak_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_streak_headline = /** @type {((inputs: Share_Streak_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Streak_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_streak_headline(inputs)
	if (locale === "es-419") return es_419_share_streak_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_share_streak_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_share_streak_headline(inputs)
	if (locale === "de-DE") return de_de2_share_streak_headline(inputs)
	if (locale === "it-IT") return it_it2_share_streak_headline(inputs)
	return en_us2_share_streak_headline(inputs)
});
export { share_streak_headline as "share.streak_headline" }